import { ImSpinner } from 'react-icons/im';

const Spinner = () => <ImSpinner data-testid="spinner" className="spinner-animation w-full h-20" />;

export default Spinner;
